import React from "react";
import SectionCard from "./SectionCard";
import "../../stylesheet/components/sections/SectionCardContainer.scss";
import { useTranslation } from "react-i18next";

const SectionCards = [
  [
    {
      title: "ZeAcademy",
      body: "Kick off your gamified blockchain learning journey, and discover all of its uses from A to Ze!",
      link: "academy",
      image: "/img/zeAcademy-logo@300w.png",
      disabled: false,
    },
    {
      title: "ZeCafe",
      body: "Keep in the loop with your daily dose of news, articles, opinion pieces, webinars, and much more.",
      link: "cafe",
      image: "/img/zeCafe-logo@300w.png",
      disabled: false,
    },
    {
      title: "Zectionary",
      body: "Your technical dictionary: Definitions, meanings, and amusing explainers",
      link: "",
      image: "/img/zectionary-logo@300w.png",
      disabled: true,
    },
    {
      title: "ZeTalent",
      body: "Scale up your talent, and offer your experience through our decentralized freelancing and peer-to-peer service platform",
      link: "",
      image: "/img/zeTalent-logo@300w.png",
      disabled: true,
    },
    {
      title: "ZeMarket",
      body: "Trade with ease, and invest in a better world by supporting humanitarian causes",
      link: "",
      image: "/img/zeMarket-logo@300w.png",
      disabled: true,
    },
    {
      title: "ZeForum",
      body: "Join our community for a range of conversations. Share your thoughts, experience, review, and more!",
      link: "",
      image: "/img/zeForum-logo@300w.png",
      disabled: true,
    },
  ],
  [
    {
      title: "أكاديمية زي",
      body: "اِبدأ/اِبدئي رحلتك التعليميّة التفاعليّة في عالم البلوكتشين، واكتشف/ي تطبيقاته العمليّة من الألف إلى الياء ",
      link: "academy",
      image: "/img/zeAcademy-logo@300w.png",
      disabled: false,
    },
    {
      title: "كافيه زي",
      body: "تابع/ي يوميّا آخر المستجدّات، وكل ما يُنشر من تقارير، ومقالات رأي، وندوات، وغير ذلك الكثير ",
      link: "cafe",
      image: "/img/zeCafe-logo@300w.png",
      disabled: false,
    },
    {
      title: "قاموس زي",
      body: "تصفّح/ي هذا القاموس المتخصّص والأوّل من نوعه باللغة العربيّة: مرادفات، ومعاني، وتعريفات مسليّة  ",
      link: "",
      image: "/img/zectionary-logo@300w.png",
      disabled: true,
    },
    {
      title: "مواهب زي",
      body: "لا تتردّد/ي في تنمية مواهبك ومشاركة خبرتك عبر استخدام منصّتنا اللامركزيّة للتوظيف والخدمات الفرديّة",
      link: "",
      image: "/img/zeTalent-logo@300w.png",
      disabled: true,
    },
    {
      title: "ماركت زي",
      body: "هذا مكانك للتداول بسهولةٍ تامّة، والاستثمار في عالمٍ أفضل من خلال دعم القضايا الإنسانيّة المتنوّعة",
      link: "",
      image: "/img/zeMarket-logo@300w.png",
      disabled: true,
    },
    {
      title: "منتديات زي",
      body: "انضمّ/ي إلى مجتمع زي، وكوني/كن جزءًا من النقاشات الواسعة التي تتناول مختلف التجارب، والأفكار، والمراجعات",
      link: "",
      image: "/img/zeForum-logo@300w.png",
      disabled: true,
    },
  ],
];

const SectionCardContainer: React.FC = () => {
  const { i18n } = useTranslation();

  let lang = 0;
  if (i18n.language === "ar") {
    lang = 1;
  }

  return (
    <div className="d-grid position-relative">
      <div className="section-card-container mt-4">
        {SectionCards[lang].map((card) => (
          <SectionCard
            key={card.title}
            card={card}
            image={card.image}
            disabled={card.disabled}
            lang={i18n.language}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionCardContainer;
